import { useCallback, useEffect } from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useAuthContext } from "@/providers/authProvider/authContext";
import { showSnackbar } from "@/utils/snackbar.helper";
import { loginRoute } from "@/routes/login";
import { getToken } from "@/utils/auth/helpers";

const useLogin = () => {
  const navigate = useNavigate();
  const { reason } = useSearch({ from: loginRoute.id });
  const { login, user, logout } = useAuthContext();

  const handleSubmit = useCallback(
    async (username: string, password: string) => {
      try {
        await login(username, password);
        // 登入後不需手動呼叫 getMe，useUserProfileQuery 的 enabled: !!token 會在 token 更新後自動觸發
      } catch (error) {
        const message = error instanceof Error ? error.message : "登入失敗";
        showSnackbar(message, "error");
      }
    },
    [login]
  );

  useEffect(() => {
    if (reason === "session-expired") {
      showSnackbar("登入已過期，請重新登入", "error");
    }
  }, [reason]);

  useEffect(() => {
    const token = getToken();

    if (!token) {
      logout();
      return;
    }

    if (user) {
      navigate({ to: "/", replace: true });
    }
  }, [user, navigate, logout]);

  return { handleSubmit };
};

export default useLogin;
